import { render } from "./settings_oauth.vue?vue&type=template&id=6e36d527&scoped=true"
import script from "./settings_oauth.vue?vue&type=script&lang=js"
export * from "./settings_oauth.vue?vue&type=script&lang=js"

import "./settings_oauth.vue?vue&type=style&index=0&id=6e36d527&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e36d527"]])

export default __exports__